<template>
  <BaseMenu
    v-model="isShown"
    v-click-outside="close"
    class="compilation-menu"
    :content-class="'compilation-edit-menu'"
    :activator="activator"
    :min-width="200"
    left
    offset-overflow
  >
    <template #content>
      <SectionsMenu
        :menu-sections="menuSections"
        @click.prevent
        @sectionsMenuEvent="sectionsMenuEventHandler"
      ></SectionsMenu>
    </template>
  </BaseMenu>
</template>

<script>
import CompilationEventsEnum from '@/enums/CompilationEventsEnum';
import PopupNamesEnum from '@/enums/PopupNamesEnum';

import SectionsMenu from '@/components/views/AppMenu/SectionsMenu/SectionsMenu';
import BaseMenu from '@/components/base/BaseMenuWithControl/BaseMenu';

import CompilationEditContextItemsEnum from '@/enums/CompilationEditContextItemsEnum';
import MenuFactory from '@/classes/factories/MenuFactory';
import { localize as $t } from '@/i18n';
import PopupEventEnum from '@/enums/PopupEventEnum';

const ORDERED_MENU_ITEMS = [
  CompilationEditContextItemsEnum.MOVE_SELECTION_TO_SECTION,
  CompilationEditContextItemsEnum.SHARE_SELECTION,
  CompilationEditContextItemsEnum.DELETE_SELECTION
];

export default {
  name: 'CompilationsEditContextMenu',
  components: { BaseMenu, SectionsMenu },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isShown: false,
      activator: ''
    };
  },
  computed: {
    isOnline() {
      return this.$store.getters['ContextStore/isOnline'];
    },
    menuSections() {
      return ORDERED_MENU_ITEMS.map(item => this.createSectionItem(item));
    }
  },
  watch: {
    isShown(val) {
      if (!val) {
        this.emit(PopupEventEnum.CLOSE);
      }
    }
  },
  mounted() {
    this.activator = `#${this.context.selector}`;
    this.isShown = true;
  },
  methods: {
    createSectionItem(sectionName) {
      const builder = MenuFactory.getMenuItemBuilder();
      let label = $t(`CompilationSelectionActionMenu.${sectionName}.label`);
      let isVisible = true;
      builder.setLabel(label).setIsVisible(isVisible);

      switch (sectionName) {
        case CompilationEditContextItemsEnum.MOVE_SELECTION_TO_SECTION:
          builder
            .setId(0)
            .setIcon('ico-drag-move-2-fill')
            .setHandler(this.$_moveToSection);
          break;
        case CompilationEditContextItemsEnum.SHARE_SELECTION:
          builder
            .setId(1)
            .setIcon('ico-share-icon')
            .setDisabled(!this.isOnline)
            .setHandler(this.$_share);
          break;
        case CompilationEditContextItemsEnum.DELETE_SELECTION:
          builder
            .setId(2)
            .setIcon('ico-delete')
            .setHandler(this.$_delete)
            .setColor('red');
          break;
      }
      return builder.build();
    },
    sectionsMenuEventHandler() {
      this.close();
    },
    $_moveToSection() {
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.MOVE_TO_SECTION_POPUP,
        popupContext: {
          paraId: this.context.paraId
        }
      });
    },
    $_duplicate() {
      this.emit(CompilationEventsEnum.DUPLICATE_SELECTION, {
        paraId: this.context.paraId
      });
    },
    $_delete() {
      this.emit(CompilationEventsEnum.REMOVE, { paraId: this.context.paraId });
    },
    $_share() {
      this.emit(CompilationEventsEnum.SHARE_SELECTION, {
        paraId: this.context.paraId
      });
    },
    close() {
      this.isShown = false;
    },
    emit(type, data = {}) {
      this.$emit('compilationMenuEvent', { type, data });
    }
  }
};
</script>

<style lang="less" src="./CompilationEditContextMenu.less"></style>
